class NsrPurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange.bind(this));
  }

  connectedCallback() {
    this.sync();
  }

  onChange(event) {
    if (!event.target.matches('[data-nsr-purchase-radio]')) return;
    this.sync();
  }

  sync() {
    const form = this.closest('form');
    if (!form) return;
    const input = form.querySelector('[data-nsr-selling-plan-input]');
    const cards = this.querySelectorAll('[data-nsr-purchase-card]');
    const radios = this.querySelectorAll('[data-nsr-purchase-radio]');
    let isSubscription = true;

    radios.forEach((radio) => {
      if (radio.checked) isSubscription = radio.value === 'sub';
    });

    cards.forEach((card) => {
      const radio = card.querySelector('[data-nsr-purchase-radio]');
      card.classList.toggle('nsr-purchase-card--selected', radio.checked);
    });

    if (input) {
      input.disabled = !isSubscription;
    }
  }
}

customElements.define('nsr-purchase-options', NsrPurchaseOptions);
